import { Component, OnInit, DoCheck } from '@angular/core';


@Component({
  selector: 'bid-dashboard',
  templateUrl: './dashboard-technology.component.html',
  styleUrls: ['./dashboard-technology.component.scss'],
})
export class DashboardTechnologyComponent implements OnInit, DoCheck {
  //showHistoricalSearch: boolean;
  constructor() {
    //this.showHistoricalSearch = false;
  }

  ngOnInit() {
    //this.showHistoricalSearchService.setShowHistoricalSearch(false);
  }

  ngDoCheck() {
    /*this.showHistoricalSearchService.getShowHistoricalSearch().subscribe((res: any) => {
      this.showHistoricalSearch = res;
    });*/
  }
}
